<template>
    <!-- 模板 -->
    <div>
        <myheader  :messages="parentMessage"></myheader>
        <!--  -->
        <div class="aboutopcomm w1750 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
            <div class="mk wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                <div class="h">小程序模板市场</div>
                <div class="p">适合自身业务场景的个性化定制专属小程序。<br/>不断深入迭代开发的数十个功能模块已覆盖诸多细分领域，让每一位客户的小程序都切实可用！ </div>
                <div class="moreboxmax">
                    <div class="a a1" @click="kefuclick"><i>在线咨询</i></div> 
                      <div class="a a2" @click="baojia">获取报价</div>
                </div>
            </div>
        </div>
        <div class="caseboxmax caseboxmax2">
            <div class="toop wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s">
                <div class="li" :class="[querInfo.classifyid==''?'cur':'']" @click="getcheck">所有</div>
                <div class="li" v-for="(item,index) in casenav" :key="index" :class="[item.id==querInfo.classifyid?'cur':'']" @click="topclick(item.id)">{{item.title}}</div>
            </div>
            <div class="mouldbox wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
                <div class="li" v-for="(item,index) in mouldlist" :key="index"  @click="caseclick(item.id)">
                    <div class="mk">
                        <div class="tp">
                            <div class="m"><img :src="item.pic" alt=""></div>
                            <div class="h">{{item.title}}</div>
                        </div>
                        <div class="p">{{item.brief}}</div>
                        <div class="a"></div>
                    </div>
                </div>
            </div>
            <div class="padeing">
                <!-- <div class="li cur">01</div>
                <div class="li">02</div>
                <div class="li">03</div>
                <div class="li prev">上一页</div>
                <div class="li next">下一页</div> -->
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="querInfo.pageNum"
                :page-size="querInfo.pageSize"
                background
                hide-on-single-page
                layout="prev, pager, next"
                :total="total"></el-pagination>
            </div>
        </div>
        <!--  -->
        <myfooter></myfooter>
		<upsform :upunm="baoMessage" @updateEvent="handleUpdate"></upsform>
    </div>
</template>

<script>
    import myfooter from './footer.vue'
    import myheader from './header.vue'
    import upsform from './upform.vue'
    export default {
        data() {
            return {
				parentMessage: 1,
                casenav: [],
                num: 0,
                mouldlist: [],
                querInfo: {
                    classifyid: '',
                    pageNum: 1,
                    pageSize: 12
                },
                total: 0,
				baoMessage: false,
            }
        },
        created() {
            this.getCaselist()
        },
        methods: {
			handleUpdate(updatedValue) {
			    this.baoMessage = updatedValue; // 更新父组件的Prop值
			},
            topclick(id){
                this.querInfo.classifyid= id;
                this.getCaselist();
            },
            // 分类
            getcheck(){
                this.querInfo.classifyid= '';
                this.getCaselist();
            },
            // 列表
            async getCaselist(){
                var url = `/api/smallapp/list?classifyid=${this.querInfo.classifyid}&pageNum=${this.querInfo.pageNum}&pageSize=${this.querInfo.pageSize}`
                const { data: res } = await this.$http.get(url)
                
                console.log(res)
                
                if(res.code !== 200){
                    return alert('获取案例失败！')
                }
                
                this.mouldlist = res.data.rows
                this.casenav = res.types
                this.total = res.data.total
                this.id = res.data.rows.id
                
            },
            handleSizeChange(newSize) {
                this.querInfo.pageSize = newSize
                this.getCaselist()
            },
            handleCurrentChange(newPage) {
                this.querInfo.pageNum = newPage
                this.getCaselist()
            },
            caseclick(id){
                const { href } = this.$router.resolve({
                    path: '/moulddata',
                    query: { id }
                })
                window.open(href, '_blank', 'noopener')
            },
			baojia() {
			    this.baoMessage = true;
			},
			kefuclick(){
			    const url = 'https://p.qiao.baidu.com/cps4/chatIndex?siteToken=fa6b3d5361002f77431328216553694d&speedLogId=16216501944184228_1621650194418_93941&eid=25401671&reqParam=%7B%22from%22%3A0%2C%22sid%22%3A%22-100%22%2C%22tid%22%3A%22-1%22%2C%22ttype%22%3A1%2C%22siteId%22%3A%2211856238%22%2C%22userId%22%3A%2225401671%22%2C%22pageId%22%3A0%7D';
			    // window.location.href = url;
			    window.open(url)
			},
        },
        components: {
        	myfooter, myheader, upsform
        }
    }
</script>

<style>
    
    .el-pagination{ display: flex;}

</style>
